module.exports = __webpack_public_path__ + "static/img/gxg_06.1c7035b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxg_img/gxg_06.png
// module id = dsDC
// module chunks = 46